/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import * as React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import styled from "styled-components";
import { withStyles } from "@material-ui/core";

import {
  StyledFormControlLabel,
  StyledHelperText,
  StyledLabel,
  StyledRequired,
} from "../superAdmin/catalog/lib/styles";
import { theme } from "../theme/theme";

const StyledRadioGroup = styled(RadioGroup)`
  margin-bottom: 14px;
  margin-left: 5px;
`;

const StyledRadio = withStyles(() => {
  return {
    root: {
      color: `${theme.color.gray300}`,
      "&$checked": {
        color: `${theme.color.gray800}`,
      },
      "&:hover": {
        backgroundColor: `${theme.color.gray200}`,
        color: `${theme.color.gray800}`,
      },
      padding: "5px",
      marginRight: "5px",
    },
    checked: {},
  };
})(Radio);

type RadioOptions = {
  id: string;
  key: string;
  name: string;
};

type RadioGroupInputFieldPropTypes = {
  disabled?: boolean;
  handleChange: (event) => void;
  helperText?: string | React.ReactChild;
  id: string;
  isRequired: boolean;
  label: string;
  options: RadioOptions[];
  value?: string;
};

const RadioGroupInputField = ({
  disabled,
  handleChange,
  helperText,
  id,
  isRequired,
  label,
  options,
  value,
}: RadioGroupInputFieldPropTypes): React.ReactElement => {
  return (
    <>
      <StyledLabel>
        {label}
        {isRequired && <StyledRequired>*</StyledRequired>}
      </StyledLabel>

      {helperText && <StyledHelperText>{helperText}</StyledHelperText>}

      <StyledRadioGroup
        aria-labelledby={`${label}-radio-group`}
        data-testid={`${id}-radio-group`}
        name="radio-buttons-group"
        onChange={handleChange}
        value={value}
      >
        {options.map((option) => {
          return (
            <StyledFormControlLabel
              control={<StyledRadio />}
              data-checked={option.id === value}
              data-disabled={disabled}
              data-testid={`${id}-${option.key}-radio`}
              disabled={disabled}
              key={option.id}
              label={option.name}
              value={option.id}
            />
          );
        })}
      </StyledRadioGroup>
    </>
  );
};

RadioGroupInputField.defaultProps = {
  helperText: "",
  value: "",
};

export default RadioGroupInputField;
